import { render, staticRenderFns } from "./CloseMenu.vue?vue&type=template&id=cc058454&scoped=true&"
import script from "./CloseMenu.vue?vue&type=script&lang=js&"
export * from "./CloseMenu.vue?vue&type=script&lang=js&"
import style0 from "./CloseMenu.vue?vue&type=style&index=0&id=cc058454&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc058454",
  null
  
)

export default component.exports